import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { DatePicker } from '@material-ui/pickers'
import DatePickerProvider from './DatePickerProvider'
import moment from 'moment'
import 'moment/locale/ja'
moment.locale('ja')

export default function MyDatePicker (props) {
  const { value, onChange } = props
  const [date, setDate] = useState(
    moment(value).isValid() ? value : null
  )

  useEffect(() => {
    setDate(moment(value).isValid() ? value : null)
  }, [value])

  useEffect(() => {
    if (onChange) {
      onChange(date)
    }
  }, [date])

  return (
    <DatePickerProvider>
      <DatePicker
        id={props.id}
        name={props.name}
        className="w-100"
        label={props.label}
        okLabel="決定"
        cancelLabel="キャンセル"
        clearLabel="クリア"
        format="YYYY-MM-DD"
        value={date}
        onChange={setDate}
        animateYearScrolling
        disabled={props.readOnly}
        required={props.required}
        clearable={!props.required}
        autoOk
        minDate={props.minDate}
        maxDate={props.maxDate}
        error={props.error}
        helperText={props.helperText}
      />
    </DatePickerProvider>
  )
}

MyDatePicker.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string
}

MyDatePicker.defaultProps = {
  minDate: '1900-01-01',
  maxDate: '9999-12-31',
  required: false,
  error: false,
  helperText: ''
}

const elem = $('.my-date-picker')
elem.each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  props.onChange = null

  ReactDOM.render(<MyDatePicker {...props}/>, el)

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
